if ($('.shopRatings, .ordering-process').length) {
  const storageKey = 'storeRatingData-' + document.location.host;
  function generateStars(score) {
    const full = Math.floor(score);
    const half = score % 1 >= 0.5;
    let html = '';

    for (let i = 0; i < full; i++) {
      html += '<span class="star star-on"></span>';
    }
    if (half && full < 5) {
      html += '<span class="star star-half"></span>';
    }
    return html;
  }
  function renderRating(data) {
    const d = typeof data === 'string' ? JSON.parse(data) : data;
    const ratings = d.ratings?.slice(0, 3) || [];
    //  console.log(d)
    const score = Math.round((parseFloat(d.averageScore) / 5) * 100)
    const reviewHtml = ratings.map(r => {
      const rawDate = r.created.date.split('.')[0];
      const dateObj = new Date(rawDate);
      const czDate = dateObj.toLocaleDateString("cs-CZ", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
      return `
          <div class="review-item">
            <div class="inner">
              <div class="header">              
                <div class="review-stars"><span class="stars">${generateStars(parseFloat(r.score) || 0)}</span></div>
              </div>
              <div class="review-description">${r.description}</div>
              <div class="rewiew-bottom">
                <div class="review-name">
                  <span class="name">${r.fullName || translation('overeneHodnoceni')}</span>
                  <span class="date">${czDate}</span>
                </div>
                <span>${translation('overeneHodnoceni')}</span>
              </div>
            </div>
          </div>
        `;
    }).join('');
    $('.shopRatings .ratingsFeed').html(reviewHtml);
    $('.shopRatings .ratingsNumber .percentil').text(score + '%');
    $('.heurekaHeader .customersPercentil').text(score + '%');
    $('.shopRatings .ratingsNumber .stars').append(generateStars(parseFloat(d.averageScore) || 0));
    $('.shopRatings .ratingsNumber p a span').text(d.count);

  }
  const stored = sessionStorage.getItem(storageKey);
  if (stored) {
    renderRating(JSON.parse(stored));
    ratingsSlider();
  } else {
    $.ajax({
      url: '/hodnotenie-obchodu/?jsonFormat',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Store-Rating-Details': 'true'
      },
      success: function (response) {
        sessionStorage.setItem(storageKey, JSON.stringify(response));
        renderRating(response);
      },
      error: function (xhr, status, error) {
        console.error('Chyba při načítání hodnocení:', error);
      }
    }).done(function () {
      ratingsSlider();
    });
  }
}

function ratingsSlider() {
  $('.shopRatings .ratingsFeed').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: false,
    arrows: true,
    infinite: false,
    adaptiveHeight: false, appendArrows: '.shopRatings .tabletHide.mobileFull',
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 2.3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1.3, slidesToScroll: 1 } }
    ]
  });




}